import { Button, Flex, Modal as AntdModal, ModalProps } from 'antd'
import { createStyles } from 'antd-style'
import { useTranslation } from 'react-i18next'

import { Text } from './Text'

const useStyle = createStyles(({ token }) => ({
  modal: {
    '& .ant-modal-content': {
      paddingInline: token.paddingLG,
      paddingBlock: token.paddingLG * 2
    },
    '.ant-modal-body': {
      padding: 0
    }
  },
  buttons: {
    width: 100
  }
}))

type Props = {
  icon: React.ReactNode
  subTitle?: React.ReactNode
} & ModalProps

export const ConfirmModal = ({
  icon,
  title,
  subTitle,
  onCancel,
  onOk,
  loading,
  ...props
}: Props) => {
  const { styles } = useStyle()
  const { t } = useTranslation()

  return (
    <AntdModal
      {...props}
      footer={null}
      centered
      onCancel={onCancel}
      className={styles.modal}
    >
      <Flex align="center" vertical gap={40}>
        <Flex align="center" gap={24} vertical>
          {icon}

          <Flex className="text-center" vertical gap={8}>
            <Text className="lh-1" size={24} weight={700}>
              {title}
            </Text>
            {subTitle}
          </Flex>
        </Flex>
        <Flex gap={8}>
          <Button
            loading={loading}
            size="large"
            onClick={onOk}
            type="primary"
            className={styles.buttons}
            {...props.okButtonProps}
          >
            {t('yes')}
          </Button>

          <Button
            size="large"
            onClick={onCancel}
            className={styles.buttons}
            {...props.cancelButtonProps}
          >
            {t('no')}
          </Button>
        </Flex>
      </Flex>
    </AntdModal>
  )
}
